import script from "./LeadForm.vue?vue&type=script&setup=true&lang=js"
export * from "./LeadForm.vue?vue&type=script&setup=true&lang=js"

import "./LeadForm.vue?vue&type=style&index=0&id=97168122&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-97168122"]])

export default __exports__